<template>
  <div class="px-5 py-4">
    <integration-page-header
      :title="$t('INTEGRATION_SETTINGS.EXTERNAL_DASHBOARD.TITLE')"
      :description="$t('INTEGRATION_SETTINGS.EXTERNAL_DASHBOARD.PAGE_DESC')"
      :hint-title="$t('INTEGRATION_SETTINGS.EXTERNAL_DASHBOARD.HINT.TITLE')"
      :hint-description="
        $t('INTEGRATION_SETTINGS.EXTERNAL_DASHBOARD.HINT.DESC')
      "
    >
      <template #actions>
        <button-v2
          v-if="hasCreatePermission('External Dashboard')"
          icon="add"
          @click="openCreatePopup"
        >
          {{ $t('INTEGRATION_SETTINGS.EXTERNAL_DASHBOARD.HEADER_BTN_TXT') }}
        </button-v2>
      </template>
    </integration-page-header>

    <woot-loading-state
      v-if="uiFlags.isFetching"
      class="mt-6"
      :message="$t('INTEGRATION_SETTINGS.EXTERNAL_DASHBOARD.LIST.LOADING')"
    />
    <p
      v-else-if="!records.length"
      class="mt-6 text-sm leading-5 text-gray-600 text-center"
    >
      {{ $t('INTEGRATION_SETTINGS.EXTERNAL_DASHBOARD.LIST.404') }}
    </p>
    <div v-else class="grid grid-cols-2 gap-4 mt-6">
      <external-dashboard-card
        v-for="dashboardAppItem in records"
        :key="dashboardAppItem.id"
        :app="dashboardAppItem"
        @edit="editApp"
        @delete="openDeletePopup"
      />
    </div>

    <dashboard-app-modal
      v-if="showDashboardAppPopup"
      :show="showDashboardAppPopup"
      :mode="mode"
      :selected-app-data="selectedApp"
      @close="toggleDashboardAppPopup"
    />

    <woot-delete-modal
      v2
      :show.sync="showDeleteConfirmationPopup"
      :on-close="closeDeletePopup"
      :on-confirm="confirmDeletion"
      :title="$t('INTEGRATION_SETTINGS.EXTERNAL_DASHBOARD.DELETE.TITLE')"
      :message="$t('INTEGRATION_SETTINGS.EXTERNAL_DASHBOARD.DELETE.MESSAGE')"
      :message-value="deleteMessage"
      message-suffix="?"
      :confirm-text="
        $t('INTEGRATION_SETTINGS.EXTERNAL_DASHBOARD.DELETE.CONFIRM_YES')
      "
      :reject-text="
        $t('INTEGRATION_SETTINGS.EXTERNAL_DASHBOARD.DELETE.CONFIRM_NO')
      "
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import DashboardAppModal from './ExternalDashboardModal.vue';
import ExternalDashboardCard from './ExternalDashboardCard.vue';
import alertMixin from 'shared/mixins/alertMixin';
import hasPermissionMixin from 'dashboard/mixins/hasPermission';
import IntegrationPageHeader from '../components/IntegrationPageHeader.vue';

export default {
  components: {
    DashboardAppModal,
    ExternalDashboardCard,
    IntegrationPageHeader,
  },
  mixins: [alertMixin, hasPermissionMixin],
  data() {
    return {
      loading: {},
      showDashboardAppPopup: false,
      showDeleteConfirmationPopup: false,
      selectedApp: {},
      mode: 'CREATE',
    };
  },
  computed: {
    ...mapGetters({
      records: 'dashboardApps/getRecords',
      uiFlags: 'dashboardApps/getUIFlags',
    }),
    deleteMessage() {
      return ` ${this.selectedApp.title}`;
    },
  },
  mounted() {
    this.$store.dispatch('dashboardApps/get');
  },
  methods: {
    toggleDashboardAppPopup() {
      this.showDashboardAppPopup = !this.showDashboardAppPopup;
      this.selectedApp = {};
    },
    openDeletePopup(response) {
      this.showDeleteConfirmationPopup = true;
      this.selectedApp = response;
    },
    openCreatePopup() {
      this.mode = 'CREATE';
      this.selectedApp = {};
      this.showDashboardAppPopup = true;
    },
    closeDeletePopup() {
      this.showDeleteConfirmationPopup = false;
    },
    editApp(app) {
      this.loading[app.id] = true;
      this.mode = 'UPDATE';
      this.selectedApp = app;
      this.showDashboardAppPopup = true;
    },
    confirmDeletion() {
      this.loading[this.selectedApp.id] = true;
      this.closeDeletePopup();
      this.deleteApp(this.selectedApp.id);
    },
    async deleteApp(id) {
      try {
        await this.$store.dispatch('dashboardApps/delete', id);
        this.showAlert(
          this.$t('INTEGRATION_SETTINGS.EXTERNAL_DASHBOARD.DELETE.API_SUCCESS')
        );
      } catch (error) {
        this.showAlert(
          this.$t('INTEGRATION_SETTINGS.EXTERNAL_DASHBOARD.DELETE.API_ERROR')
        );
      }
    },
  },
};
</script>
